<div class="filter-for-list" *ngIf="!readOnly">
    <mat-form-field class="mini-list-header" placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
    </mat-form-field>
    <div class="buttons-cont">
        <button type="button" class="btn top-list-tools"
                (click)="openModal()" placement="left"
                [ngbTooltip]="'CREATE_LOCATION_TOOLTIP' | translate">
            <fa-icon [icon]="faPlus"></fa-icon>
            {{'ADD_LOCATION'|translate}}
        </button>
        <button type="button" class="btn btn-danger"
                (click)="removeAllLocations()" placement="left"
                [ngbTooltip]="'REMOVE_ALL_LOCATIONS_TOOLTIP' | translate">
            <fa-icon [icon]="faTimes"></fa-icon>
            {{'REMOVE_ALL_LOCATIONS'|translate}}
        </button>
    </div>
    <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<table mat-table [dataSource]="alarmLocations" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let location"> {{location.id}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
        <td mat-cell *matCellDef="let location"><b>{{location.name}}</b>
        </td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> {{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let location">

            <mat-icon style="color:red;cursor:pointer" (click)="removeLocationToProject(location)"
                      matTooltipPosition="right"
                      [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
            </mat-icon>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5"
               *ngIf="!readOnly"></mat-paginator>
